<template>
  <div class="relative flex gap-3">
    <div
      class="absolute z-10 min-h-[20px] min-w-[20px] pr-1 duration-300"
      :class="props.selected && 'bg-[#CCF2C8] dark:bg-[#333639]'"
    >
      <PlaceIcon class="fill-[#B3B3B3] duration-300 dark:group-hover:fill-white" />
    </div>
    <p
      id="autocomplete-place-text"
      class="pl-8"
      :class="!props.selected && 'overflow-hidden text-ellipsis'"
    >
      {{ props.place.description }}
    </p>
  </div>
</template>

<script setup>
import PlaceIcon from '@/components/ui/icons/PlaceIcon.vue'
const props = defineProps({
  place: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    required: true,
    default: false
  }
})
</script>
